import type { BusinessNumberState } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { FormField } from '@/shared/ui';

export const BusinessNumberField = ({
  value,
  onChange,
  onBlur,
  state,
  isPending,
  error,
}: {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onBlur: () => void;
  readonly state: BusinessNumberState | null;
  readonly isPending: boolean;
  readonly error?: string | undefined;
}): ReactElement => {
  return (
    <div className="flex flex-col gap-2">
      <FormField
        label="사업자등록번호"
        isRequired
        required
        className="h-11"
        value={value}
        inputMode="numeric"
        maxLength={10}
        error={error}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
      />
      <div aria-live="polite">
        {isPending ? (
          <p role="status" className="text-xs text-muted-foreground">
            사업자등록번호 확인 중입니다.
          </p>
        ) : null}
        {state === 'ACTIVE' ? <p className="text-xs text-muted-foreground">확인됨</p> : null}
        {state === 'SUSPENDED' ? (
          <p className="text-xs text-amber-700">
            휴업한 사업자입니다. 정보를 확인한 뒤 주문해 주세요.
          </p>
        ) : null}
        {state === 'CLOSED' ? (
          <p role="alert" className="text-xs text-destructive">
            폐업한 사업자등록번호로는 세금계산서를 요청할 수 없습니다.
          </p>
        ) : null}
      </div>
    </div>
  );
};
